import React from "react";
const SchedulerContext = React.createContext({});
export const SchedulerProvider = SchedulerContext.Provider;
export default SchedulerContext;

